module.exports = __webpack_public_path__ + "static/img/lbsl.15b3fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbsl.png
// module id = YvbG
// module chunks = 0